import Repository from './repository'

export default {
    AlunosGet (treinadorId) {
        return Repository.get(`coaches/${treinadorId}/students`)
    }
}

